import { Box, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import {
  blackShade19,
  blackShade23,
  border25,
  mobilePrimary,
  redShade12,
  redShade13,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import VariantInventoryCard from "./VariantInventoryCard";
import { getInventoryChildVariantProductsAPI } from "../../../service/api_calls/inventory/InventoryApi";
import {
  filterPriceUpdateProducts,
  prepareLowAndOOSProducts,
} from "../../../reducers/inventory/inventoryHelper";
import { getDiscountPercentage } from "../../../utils/helper";

function MobileVariantInventory({ products, status }) {
  const [selectedMainVariant, setSelectedMainVariant] = useState(null);
  const [childProducts, setChildProducts] = useState(null);
  const [tableHeader, setTableHeader] = useState([]);
  const [childProductsLoader, setChildProductsLoader] = useState(false);

  const fetchChildVariants = async (product) => {
    if (product?.productId === selectedMainVariant) {
      setSelectedMainVariant(null);
      return;
    }
    setSelectedMainVariant(product?.productId);
    setChildProductsLoader(true);

    const businessId = sessionStorage.getItem("selectedBusinessId");

    const payload = {
      businessId,
      masterProductVariantId: product?.variantInfo?.masterProductVariantId,
      status,
    };

    const res = await getInventoryChildVariantProductsAPI(payload);

    if (res?.details) {
      const productsData = res?.details || [];

      const filteredList = filterPriceUpdateProducts(productsData);

      if (filteredList?.length > 0) {
        const productInfo = filteredList?.[0];

        let header = [];

        productInfo?.variantInfo?.variants?.forEach((element) => {
          if (element?.code === "uom") {
            header = [
              ...header,
              { title: "Unit of Measure" },
              { title: "UOM Value" },
            ];
          } else header = [...header, { title: element?.code }];
        });

        setTableHeader([
          ...header,
          {
            id: 33,
            title: "Photo",
          },
        ]);
      }
      setChildProducts(filteredList);
    }
    setChildProductsLoader(false);
  };
  return (
    <Box>
      <Stack gap={1} sx={styles.infoCard}>
        <Typography
          fontSize={12.5}
          color={blackShade19}
          fontWeight={500}
          textAlign={"center"}
          lineHeight={1.6}
        >
          Variants update is currently available only on our{" "}
          <span style={{ color: mobilePrimary, fontWeight: 600 }}>
            browser web version.
          </span>
        </Typography>
        <Typography
          fontSize={12.5}
          color={blackShade19}
          fontWeight={500}
          textAlign={"center"}
          lineHeight={1.6}
        >
          For the best experience and to use this feature, please switch to a{" "}
          <span style={{ color: mobilePrimary, fontWeight: 600 }}>
            desktop or laptop computer
          </span>{" "}
          and access our site through a standard web browser.
        </Typography>
      </Stack>
      <Box
        sx={{
          width: "100%",
          backgroundColor: whiteColor,
          borderRadius: "10px",
          border: border25,
          overflow: "hidden",
          mt: 2,
        }}
      >
        <Box sx={{ borderBottom: border25, p: "5px 10px" }}>
          <Typography
            fontSize={12}
            fontWeight={500}
            lineHeight={1.5}
            color={blackShade23}
          >
            Products
          </Typography>
        </Box>
        {products.map((item, index) => (
          <VariantInventoryCard
            key={"product" + index}
            img={item?.productPhoto?.[0]?.docURL}
            originalAmt={item?.productOriginalPrice}
            amt={item?.productSalePrice}
            priceOff={getDiscountPercentage(
              item?.productSalePrice,
              item?.productOriginalPrice
            )}
            ondcEnabled={item?.ondcEnabled?.toLowerCase() == "yes"}
            productName={item?.productName}
            onMainProductClick={() => fetchChildVariants(item)}
            showChild={selectedMainVariant === item?.productId}
            count={item?.count || "X"}
            childProducts={childProducts}
            tableHeader={tableHeader}
            loader={childProductsLoader}
          />
        ))}
      </Box>
    </Box>
  );
}

export default MobileVariantInventory;

const styles = {
  infoCard: {
    backgroundColor: redShade12,
    p: "10px 15px",
    border: "1px solid " + redShade13,
    borderRadius: "8px",
  },
};
